function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from "./Icon";
/* eslint-disable max-len */

var BinIcon = function BinIcon(props) {
  return React.createElement(Icon, _extends({
    width: "22",
    height: "22",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#FF6982"
  }, props), React.createElement("path", {
    d: "M3.21436 6.99934H3.77403L5.74846 16.7555C6.01274 18.0613 7.16053 19.0001 8.49283 19.0001H13.7213C15.0536 19.0001 16.2013 18.0613 16.4656 16.7555L18.4401 6.99934H19.0001C19.4419 6.99934 19.8001 6.64117 19.8001 6.19934C19.8001 5.75751 19.4419 5.39934 19.0001 5.39934H14.7972L14.4822 3.8429C14.3123 3.00345 13.5744 2.39995 12.7179 2.39995H9.49657C8.64009 2.39995 7.90223 3.00344 7.73234 3.8429L7.41734 5.39934H3.21436C2.77253 5.39934 2.41436 5.75751 2.41436 6.19934C2.41436 6.64117 2.77253 6.99934 3.21436 6.99934ZM5.40659 6.99996L16.8075 7.00007L14.8974 16.4381C14.7841 16.9978 14.2922 17.4001 13.7213 17.4001H8.49283C7.92184 17.4001 7.42993 16.9978 7.31667 16.4381L5.40659 6.99996ZM12.914 4.16028L13.1647 5.39934H9.04978L9.30054 4.16028C9.31942 4.06701 9.4014 3.99995 9.49657 3.99995H12.7179C12.8131 3.99995 12.8951 4.06701 12.914 4.16028Z",
    stroke: "white",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6815 16.5968C15.4927 17.5295 14.6729 18.2001 13.7213 18.2001H8.49283C7.54118 18.2001 6.72133 17.5295 6.53257 16.5968L4.42847 6.19995L17.7856 6.20008L15.6815 16.5968Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.143 6.19995H8.07153L8.51644 4.00159C8.61082 3.53523 9.02075 3.19995 9.49657 3.19995H12.7179C13.1937 3.19995 13.6037 3.53523 13.6981 4.00159L14.143 6.19995Z",
    fill: "white",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M3.21436 6.19934H19.0001",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M12.6499 13.9841L13.6985 9.89995",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), React.createElement("path", {
    d: "M9.6499 13.9841L8.60132 9.89995",
    stroke: "currentColor",
    strokeWidth: "1.6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

export default BinIcon;